import React, { useRef, useState } from "react"
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button
} from "reactstrap";
// core components
import Header from "../../../components/headers/Header";
//import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import MessageBox from "../../../components/ui/MessageBox";
import "../../../assets/scss/screens/admin/unit/fields/types/uploadImage.scss";
import * as Helper from "../../../utils/Helper";
import { Upload, Icon, Button as AntdBtn } from "antd";
import "antd/dist/antd.css";
import { UploadOutlined } from "@ant-design/icons";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/book/EditRawUnitRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService } from "../../../navigation";
import UIDs from "../../../UIDs";
import "../../../assets/scss/screens/admin/unittask/unittask.scss";

const uid = UIDs.screens.admin.book.editrawunit;
//const { Dragger } = Upload;

class EditRawUnitScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_RAWUNIT_ASYNC]: { done: this._handleSaveRawUnitAsyncDone, error: this._handleAsyncActionError }
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id, sectionId } = this.localVars.navParams;
        let vo = { id, sectionId };
        this.props.loadScreenViewAsync(vo);
    }

    render() {
        const { rawUnit } = this.props.localState;

        return (
            <>
                <Header />
                <Container className="mt--7  aic-unittask-style" fluid>
                    <Row>
                        <div className="col">
                            <EditForm
                                {...this.props}
                                rawUnit={rawUnit}
                                onCancel={this._handleCancelEdit}
                                onSave={this._handleSaveRawUnit}
                                onUpload={this.props.uploadImageAsync}
                                onRemove={this.props.removeImage}
                                localVars={this.localVars.navParams}
                                isDisabled={this.isActionExecuting(ActionTypes.SAVE_RAWUNIT_ASYNC)}
                                showLoading={this.isActionExecuting(ActionTypes.UPLOAD_IMAGE_ASYNC)}
                            />
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleCancelEdit = () => {
        const { courseId, sectionId } = this.localVars.navParams;
        NavigationService.navigateToPage(this, `/admin/book/${courseId}/details`, { sectionId });
    }

    _handleSaveRawUnit = (data) => {
        const { rawUnit, isUpdate } = this.props.localState;
        if (!rawUnit.images || rawUnit.images.length === 0) {
            MessageBox.danger({ text: this.props.t("mustPicture"), duration: 5000 });
            return;
        }

        if (!isUpdate) {
            MessageBox.danger({ text: this.props.t("needChangePicture"), duration: 5000 });
            return;
        }

        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        if (rawUnit.images.length > 2) {
                            MessageBox.danger(this.props.t("note"));
                            return;
                        }

                        if ( rawUnit.status === 1) {
                            rawUnit.status = 2;
                        }
                        let id = rawUnit.id ? rawUnit.id : "";
                        let sectionId = rawUnit.sectionId ? rawUnit.sectionId : "";
                        let unitId = rawUnit.unitId ? rawUnit.unitId : "";
                        let images = "[\"" + rawUnit.images.join("\",\"") + "\"]";
                        let vo = {...rawUnit, id, sectionId, unitId, images};
                        this.props.saveRawUnitAsync(vo);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleSaveRawUnitAsyncDone = () => {
        const { courseId, sectionId } = this.localVars.navParams;
        NavigationService.navigateToPage(this, `/admin/book/${courseId}/details`, { sectionId });
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }
}

function EditForm(props) {
    const { rawUnit, localVars, showLoading } = props;
    const { id, sectionId, images, status = 0, sectionName, count } = rawUnit || {};
    const { register, handleSubmit } = useForm();
    const [loading, setLoading] = useState(false);
    const submitRef = useRef();
    /*const uploadButton = (
        <AntdBtn>
            {loading && images && images.length > 1 ? <Icon type="loading" /> : <UploadOutlined />}{props.t("upload")}
        </AntdBtn>
    );*/

    const uploadButton =  showLoading ? <Icon type="loading" style={{fontSize:50}} /> : <AntdBtn><UploadOutlined />{props.t("upload")}</AntdBtn>

    const uploadProps = {
        name: "fileData",
        showUploadList: false, // set to only upload one file        
        customRequest: info => {
            props.onUpload(info.file, id);
        },
        onChange: info => {
            if (info.file.status === "uploading") {
                setLoading(true);
            }
        },
        listType: "picture-card",
        className: "avatar-uploader",
        beforeUpload: file => {
            const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
            if (!isJpgOrPng) {
                MessageBox.danger(props.t("uploadImageFormatLimited"));
                return false;
            }
            const isLt2M = file.size / 1024 / 1024 < 5;
            if (!isLt2M) {
                MessageBox.danger(props.t("uploadImageSizeLimited", { fileSize: 5 }));
                return false;
            }
            return isJpgOrPng && isLt2M;
        }
    };

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <h3 className="mb-0">
                            {sectionName}{"/"}{props.t("index", {index: localVars.id ? localVars.index : count + 1})}
                            <span style={{marginLeft: 10, fontSize: 14, backgroundColor: "#1E90FF", color: "#FFF", width: "auto"}}>
                                {status === 0 ? props.t("unsubmitted") : (status === 1 ? props.t("submitted") : props.t("modified") )}
                            </span>
                        </h3>
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitRef.current.click()}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            onClick={props.onCancel}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("cancel")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <input name="id" hidden type="text" className="form-control" defaultValue={id} ref={register} />
                    <input name="sectionId" hidden type="text" className="form-control" defaultValue={sectionId} ref={register} />
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group" style={{float:"left"}}>
                                    {images && images[0] && images[0] !== "" ? <img src={Helper.convertToFileServerPath(images[0])} alt="..."  className="originalPicture" />
                                    : 
                                    <Upload {...uploadProps}>
                                        {uploadButton}
                                    </Upload>}
                                </div>
                                {images && images[0] && images[0] !== "" && <div>
                                    <i class="fa fa-times" aria-hidden="true" style={{marginLeft:"10px"}}
                                        onClick={(e) => {props.onRemove(0)}}
                                    ></i>
                                </div>}
                            </div>
                        </div>
                    </div>
                    {images && images[0] && images[0] !== "" && <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group" style={{float:"left"}}>
                                    {images && images[1] && images[1] !== "" ? <img src={Helper.convertToFileServerPath(images[1])} alt="..."  className="originalPicture" />
                                    : 
                                    <Upload {...uploadProps}>
                                        {uploadButton}
                                    </Upload>}
                                </div>
                                {images && images[1] && images[1] !== "" && <div>
                                    <i class="fa fa-times" aria-hidden="true" style={{marginLeft:"10px"}}
                                        onClick={(e) => {props.onRemove(1)}}
                                    ></i>
                                </div>}
                            </div>
                        </div>
                    </div>}
                    <div style={{color: "#1E90FF"}}>{props.t("note")}</div>
                    <input ref={submitRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: vo => dispatch(Actions.loadScreenViewAsync(vo)),
        saveRawUnitAsync: vo => dispatch(Actions.saveRawUnitAsync(vo)),
        uploadImageAsync: (file, id) => dispatch(Actions.uploadImageAsync(file, id)),
        removeImage: (index) => dispatch(Actions.removeImage(index)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditRawUnitScreen));